import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { Wrench, Check } from "lucide-react";

export default function DatiDaSistemare() {
  const [d, setD] = useState(null);
  const load = () => api.get("/dati-da-sistemare").then((r) => setD(r.data)).catch((e) => toast.error(apiError(e)));
  useEffect(() => { load(); }, []);
  const ok = async (id) => { try { await api.delete(`/dati-da-sistemare/${id}`); load(); } catch (e) { toast.error(apiError(e)); } };
  const corretti = Object.values(d?.corretti || {}).reduce((s, n) => s + n, 0);
  return (
    <div className="fade-up" data-testid="dati-da-sistemare-page">
      <h1 className="font-display text-2xl font-extrabold flex items-center gap-2 mb-2"><Wrench className="text-[#FC82ED]" /> Dati da sistemare</h1>
      <p className="text-sm text-[var(--muted)] mb-4" data-testid="dds-riepilogo">Dati che non è stato possibile dividere con sicurezza nei campi separati: aprili e completali a mano.{d?.eseguita_at ? ` Correzione automatica eseguita: ${corretti} record sistemati.` : ""}</p>
      {!d ? <div className="skeleton h-40 rounded-2xl" /> : d.righe.length === 0 ? <div className="card-immo p-8 text-center text-[var(--muted)]" data-testid="dds-vuoto">Nessun dato da sistemare.</div> : (
        <div className="card-immo divide-y divide-[var(--border)]">{d.righe.map((r) => (
          <div key={r.id} data-testid={`dds-row-${r.id}`} className="p-3 flex flex-wrap items-center gap-3 text-sm">
            <span className="px-2 py-0.5 rounded-full bg-slate-100 text-xs font-semibold">{r.tipo}</span>
            <span className="text-xs text-[var(--muted)]">{r.campo}</span>
            <b className="flex-1 min-w-[160px]">{r.valore}</b>
            <Link to={r.link} data-testid={`dds-apri-${r.id}`} className="text-xs font-semibold text-[#FC82ED] underline">Apri scheda</Link>
            <button data-testid={`dds-risolto-${r.id}`} onClick={() => ok(r.id)} className="inline-flex items-center gap-1 px-3 py-1.5 rounded-lg border border-[var(--border)] text-xs font-semibold"><Check size={13} /> Sistemato</button>
          </div>))}</div>)}
    </div>);
}
